import React from 'react';
import { get, post, put, del } from '../../Utility/Http';
import { getPlayerApiGet, getCoachApiGet,createTeam,getTeamApiGet,playerCreateApiGet,playerStatusPut} from './TeamModel';
import Config from '../../Utility/Config';

export const getPlayerListApi = async () => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}user/coach/get-players`, null);
    return getPlayerApiGet(response);
};

export const getCoachListApi = async () => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}admin/get-coach`, null);
    return getCoachApiGet(response);
};
export const getTeamListApi = async () => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}admin/team/list`, null);
    return getTeamApiGet(response);
};

export const createTeamApi = async (data) => {
    const response = await post(`${Config.EXTENDED_URL}user/coach/team/create`, data, null);
    return createTeam(response);
};

export const playerCreateApi = async (data) => {
    const response = await post(`${Config.EXTENDED_URL}user/coach/player-create`, data, null);
    return playerCreateApiGet(response);
};
export const playerStatusApi = async (playerId) => {
    console.log(process.env.EXTENDED_URL);
    const response = await put(`${Config.EXTENDED_URL}user/coach/approve-player/${playerId}`, null);
    return playerStatusPut(response);
};

export const getTeamDetailsApi = async (teamId) => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}user/coach/team/read/${teamId}`, null);
    // return getTeamApiGet(response);
    return response?.data;
};

export const getPlayerDetailsApi = async (playerId) => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}user/coach/team/read/${playerId}`, null);
    return response?.data;
};

